import { Component, OnInit, Input, ChangeDetectionStrategy, NgModule, Inject } from '@angular/core';
import { SiteService } from '@app/services/site.service';
import { Observable, Subject, of } from 'rxjs';
import { NewsPage } from '@app/models/news-page';
import { startWith, map, catchError, mergeMap } from 'rxjs/operators';
import { UserChannelTermsService } from '@app/services/user-channel-terms.service';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { TextPlaceholderModule } from '@app/components/text-placeholder/text-placeholder.component';
import { ErrorTemplatesModule } from '@app/components/error-templates/error-templates.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { LinkModule } from '@app/directives/link.directive';
import { RouterModule } from '@angular/router';
import { NewsCardListModule } from '@app/components/news-card-list/news-card-list.component';
import { ComplimentsService } from '../services/compliments.service';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { CafcassEnvironment } from '../../environments/cafcassEnvironment';

@Component({
  selector: 'app-custom-compliments-wall',
  templateUrl: './custom-compliments-wall.component.html',
  styleUrls: ['./custom-compliments-wall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomComplimentsWallComponent implements OnInit {

  @Input() amountOfComplimentsToDisplay = 6;
  @Input() maxNumberOfShowMore = 2; // How many times can you press the show more button

  private errorSubject$ = new Subject();
  private moreComplimentPostsSubject = new Subject<number>();
  personalComplimentItems$: Observable<Array<NewsPage>>;

  fetchedAmountOfPosts = 0;
  amountOfNewsToIncreaseWith = this.amountOfComplimentsToDisplay;
  amountOfComplimentPostsToDisplayCurrently = this.amountOfComplimentsToDisplay;
  numberOfShowMoreClicks = 0;

  complimentsWallUrl: string;
  loading = false;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: CafcassEnvironment,
              private service: ComplimentsService,
              private userChannelTermsService: UserChannelTermsService,
              private siteService: SiteService) { }

  ngOnInit() {

    this.complimentsWallUrl = this.environment.complimentsWallSiteUrl;

    this.personalComplimentItems$ = this.moreComplimentPostsSubject
      .pipe(
        startWith(this.amountOfComplimentPostsToDisplayCurrently + 1),
        mergeMap(() => {
          this.loading = true;
          const channels$ = this.userChannelTermsService.getUserChannelTerms();
          return this.service.getMyModernPersonalNewsFromComplimentSite(channels$);
        }),
        map((pages) => {
          pages.forEach(page => {
            if (page && (!page.SiteName || !page.SiteUrl)) {
              page.SiteInfo$ = this.siteService.getSiteInfoFromUrl(page.Path);
            }
          });

          this.fetchedAmountOfPosts = pages.length;
          if (this.fetchedAmountOfPosts > this.amountOfComplimentPostsToDisplayCurrently) {
            pages = pages.slice(0, this.amountOfComplimentPostsToDisplayCurrently);
          }
          this.loading = false;
          return pages;
        }),
        catchError(err => {
          this.errorSubject$.next(err);
          return of(null);
        }));
  }

  showMoreComplimentPosts() {
    this.numberOfShowMoreClicks++;
    this.amountOfComplimentPostsToDisplayCurrently = this.amountOfComplimentPostsToDisplayCurrently + this.amountOfNewsToIncreaseWith;
    this.loading = true;
    this.moreComplimentPostsSubject.next(this.amountOfComplimentPostsToDisplayCurrently + 1);
  }
}
@NgModule({
  entryComponents: [CustomComplimentsWallComponent],
  declarations: [CustomComplimentsWallComponent],
  exports: [CustomComplimentsWallComponent],
  imports: [
    CommonModule,
    NewsCardListModule,
    LinkModule,
    ActionLinkModule,
    MatButtonModule,
    RouterModule,
    ErrorTemplatesModule,
    TextPlaceholderModule,
    WidgetPlaceholderModule
  ]
})
export class CustomComplimentsWallModule { }
